import { useState, useEffect } from 'react';

interface PestControlPremiseProps {
    premiseType: string;
    onSelect: (service: { title: string; price: string }, isSelected: boolean) => void;
    selectedServices: Set<{ title: string; price: string }>;
    onSelectionChange: (hasSelection: boolean) => void;
}

const PestControlBooking = ({ 
    premiseType, 
    onSelect, 
    selectedServices,
    onSelectionChange
}: PestControlPremiseProps) => {
    const [isSelected, setIsSelected] = useState(false);

    useEffect(() => {
        const existingService = Array.from(selectedServices).find(service => 
            service.title.startsWith(premiseType)
        );
        setIsSelected(existingService !== undefined);
    }, [selectedServices, premiseType]);

    const handleToggle = () => {
        const newIsSelected = !isSelected;
        const service = {
            title: `${premiseType} (Harga bermula RM88)`,
            price: 'Tertakluk kepada saiz premis'
        };
        onSelect(service, newIsSelected);
        setIsSelected(newIsSelected);
        onSelectionChange(newIsSelected);
    };

    return (
        <div className="relative">
            <button
                type="button"
                onClick={handleToggle}
                className={`px-3 py-1.5 rounded-md text-xs flex items-center ${
                    isSelected ? 'bg-blue-800 text-white' : 'bg-gray-100 text-gray-700'
                }`}
            >
                {isSelected ? `${premiseType}` : premiseType}
            </button>
            {isSelected && selectedServices.size > 0 && (
                <div className="mt-1 text-xs text-gray-500 italic">
                    *Harga akan dibincangkan
                </div>
            )}
        </div>
    );
};

export default PestControlBooking; 